/**
 * Publishes the first-order code for display.
 * Shopify Admin enforces once-per-customer and zero-order eligibility.
 * This file does not apply, remove, or block discount codes.
 */
const configEl = document.getElementById("vow-welcome-offer-config");

let code = "WELCOME15";
try {
  const config = JSON.parse(configEl?.textContent || "{}");
  if (typeof config.code === "string" && config.code.trim()) {
    code = config.code.trim().toUpperCase();
  }
} catch {
  code = "WELCOME15";
}

window.VowWelcomeOffer = { code };
